import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "lpu-prices-service rounded-20",
      class: [
        _setup.isMobile ? "pa-4" : "px-4 py-3",
        { "bg-gray-40": _vm.isStriped },
      ],
      attrs: { "data-qa": "lpu_services_service" },
    },
    [
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: _setup.isMobile ? "flex-column ga-3" : "align-center ga-8",
        },
        [
          _c(
            "div",
            {
              staticClass: "lpu-prices-service__name text-body-1 min-w-0",
              class: { "flex-grow-1": !_setup.isMobile },
              attrs: { "data-qa": "lpu_services_service_name_text" },
            },
            [
              _vm._v("\n      " + _vm._s(_setup.name) + "\n      "),
              _setup.durationLabel
                ? _c(
                    "div",
                    {
                      staticClass: "text-body-2 text-secondary--text",
                      attrs: { "data-qa": "lpu_services_service_duration" },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_setup.durationLabel) + "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "d-flex align-center flex-shrink-0",
              class: _setup.isMobile ? "justify-space-between w-100" : "ga-8",
            },
            [
              _c(
                "div",
                {
                  staticClass: "text-subtitle-1 text--text flex-shrink-0",
                  class: { "text-right": !_setup.isMobile },
                  attrs: { "data-qa": "lpu_services_service_price_full_text" },
                },
                [_vm._v("\n        " + _vm._s(_setup.priceLabel) + "\n      ")]
              ),
              _vm._v(" "),
              _setup.showActionsColumn
                ? _c(
                    "div",
                    {
                      staticClass: "lpu-prices-service__actions flex-shrink-0",
                    },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass:
                            "branding-btn branding-btn--primary rounded-20 text-none text-subtitle-1",
                          class: {
                            "lpu-prices-service__btn-ghost":
                              !_setup.showAppointmentButton,
                          },
                          attrs: {
                            depressed: "",
                            color: "primary",
                            height: _setup.isMobile ? 48 : 52,
                            loading: _setup.isLoading,
                            tabindex: _setup.showAppointmentButton
                              ? undefined
                              : -1,
                            "aria-hidden": !_setup.showAppointmentButton,
                            "data-qa": _setup.showAppointmentButton
                              ? "lpu_services_service_price_full_button"
                              : undefined,
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _setup.onAppointmentClick.apply(
                                null,
                                arguments
                              )
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.tStatic("Запись онлайн")) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _setup.showToggle
                        ? _c(
                            VBtn,
                            {
                              staticClass:
                                "branding-btn branding-btn--background lpu-prices-service__toggle-btn",
                              attrs: {
                                depressed: "",
                                width: "40",
                                height: "32",
                                "min-width": "40",
                                "data-qa":
                                  "lpu_services_service_price_toggle_calendar",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.emit("close-calendar")
                                },
                              },
                            },
                            [_c("span", { staticClass: "ui-icon-arrow-up" })]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.isCalendarOpen
        ? _c(
            "div",
            {
              staticClass:
                "lpu-prices-service__calendar d-flex flex-column ga-3 mt-3 mx-n3",
            },
            [
              !_setup.isMobile
                ? _c("div", { staticClass: "lpu-prices-service__divider" })
                : _vm._e(),
              _vm._v(" "),
              _c(_setup.PricesServiceCalendar, {
                attrs: {
                  "day-items": _setup.dayItems,
                  "active-date": _setup.activeDate || undefined,
                  "active-day-slots": _setup.activeDaySlots,
                },
                on: {
                  "select-day": _setup.selectDay,
                  slot: _setup.onCalendarSlot,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }